import { baseUrl } from './env'
import axios from 'axios'
import { Message } from 'element-ui'
axios.defaults.headers.common['token'] = window.sessionStorage["accessToken"];
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use((res) => {
    if (res.status >= 200 && res.status < 300) {
        return res;
    }
    return Promise.reject({ message: '请求异常，请重试', err: res });
}, (error) => {
    // 网络异常
    return Promise.reject({ message: '网络异常，请刷新重试', err: error });
});

export default async (url = '', data = {}, type = 'GET', queryData = {}, showError = true) => {
    type = type.toUpperCase();
    url = url;

    if (type == 'GET') {
        queryData = data;
    }
    let option = {
        method: type,
        url: url,
        params: queryData,
        data: data
    }
    try {
        const response = await axios({
            method: type,
            url: url,
            params: queryData,
            data: data
        });
        if (response.data.code == 401) {
            location.href = '/login'
            return response.data
        } else {
            return response.data
        }


    } catch (error) {
        console.log(error);
        let resp = error.err.response && error.err.response.data ? error.err.response.data : { code: error.err.response.staus, message: error.err.response.statusText };

        if (showError) {

            // Message.error(resp.message+"（"+resp.code+"）")
        }
        return resp;
    }

}



// WEBPACK FOOTER //
// ./src/config/axios-fetch.js